module.exports = __webpack_public_path__ + "img/passo_03.cc474d0b.png";